export default "__VITE_PUBLIC_ASSET__dd07f433__"